import Button from '@components/Button/Button';
import Popover, { positionBounded } from '@components/Popover/Popover';
import { ContentSection, TitleSection } from '@components/Popover/PopoverLayouts';

import styles from './CardHeader.module.scss';
import type { ImageType } from './utilities';

interface NextImagePopoverProps {
  targetNode: HTMLElement | undefined;
  show: boolean | undefined;
  onClose: () => void;
  onYes: (type: ImageType) => void;
}

const NextImagePopover: React.FC<React.PropsWithChildren<NextImagePopoverProps>> = ({
  targetNode,
  show,
  onClose,
  onYes,
}) => {
  return (
    <>
      <Popover
        positioner={positionBounded({
          offsetX: 8,
          xPreference: 'right',
          alignY: 'cover',
          adaptive: false,
        })}
        targetNode={targetNode}
        show={!!show}
        onClose={onClose}
        preventOutsideInteraction
        drawFocus={true}
      >
        <TitleSection text="Would you like to upload a profile picture?" onClose={onClose} />
        <ContentSection>
          <div className={styles['next-image']}>
            <div className={styles['next-image-buttons']}>
              <Button variant="secondary" onClick={onClose}>
                No
              </Button>
              <Button onClick={() => onYes('profile')}>Yes</Button>
            </div>
          </div>
        </ContentSection>
      </Popover>
    </>
  );
};

export default NextImagePopover;
